import type { AdoptionRow } from '@/types'
import { CHANGE_LABEL } from './constants'

export function AdoptionTable({ rows }: { rows: AdoptionRow[] }) {
  if (rows.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-gray-300 p-4 text-sm text-gray-400">
        采纳总表 — no variants marked “use” yet
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white overflow-x-auto">
      <div className="px-3 py-2 text-sm font-semibold border-b bg-gray-50">
        采纳总表 ({rows.length})
      </div>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-gray-500 border-b">
            <th className="px-3 py-1.5">Country</th>
            <th className="px-3 py-1.5">Slug</th>
            <th className="px-3 py-1.5">Variant</th>
            <th className="px-3 py-1.5">Reviewer</th>
            <th className="px-3 py-1.5">加工%</th>
            <th className="px-3 py-1.5">加工项</th>
            <th className="px-3 py-1.5">Note</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={`${row.shoot_id}-${row.variant}-${row.reviewer_email}-${i}`} className="border-b last:border-0">
              <td className="px-3 py-1.5 whitespace-nowrap">{row.country}</td>
              <td className="px-3 py-1.5">
                <a href={`#${row.slug}`} className="text-blue-600 hover:underline">
                  {row.slug}
                </a>
              </td>
              <td className="px-3 py-1.5">v{row.variant}</td>
              <td className="px-3 py-1.5 whitespace-nowrap">{row.reviewer_email.split('@')[0]}</td>
              <td className="px-3 py-1.5">{row.post_processing_pct}%</td>
              <td className="px-3 py-1.5">
                {row.changes.map((c) => CHANGE_LABEL[c] ?? c).join('、')}
              </td>
              <td className="px-3 py-1.5 max-w-[280px] truncate" title={row.note ?? ''}>
                {row.note}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
